<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <div class="modal-title" i18n>Connect To Booking.com</div>
    <app-page-help articleId="2mx4rvnhrd" videoId="-"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<mat-stepper [linear]="true" #stepper class="m-3">
  <mat-step
    i18n-label
    label="Getting Started"
    [editable]="stepper.selectedIndex < 3"
    [state]="stepper.selectedIndex > 0 ? 'done' : 'number'"
  >
    <app-connect-bdc-wizard-step1 (next)="stepper.next()"></app-connect-bdc-wizard-step1>
  </mat-step>
  <mat-step
    i18n-label
    label="Preparation"
    [optional]="true"
    [editable]="stepper.selectedIndex < 3"
    [state]="stepper.selectedIndex > 1 ? 'done' : 'number'"
  >
    <app-connect-bdc-wizard-step2
      [channel]="channel"
      (prev)="stepper.previous()"
      (next)="stepper.next()"
      #step2
    ></app-connect-bdc-wizard-step2>
  </mat-step>
  <mat-step
    i18n-label
    label="Request Channel Manager Access"
    [optional]="true"
    [editable]="stepper.selectedIndex < 3"
    [state]="stepper.selectedIndex > 2 ? 'done' : 'number'"
  >
    <app-connect-bdc-wizard-step3
      (prev)="stepper.previous()"
      [channel]="channel"
      (connected)="onConnected($event)"
      #step3
    ></app-connect-bdc-wizard-step3>
  </mat-step>
  <mat-step
    i18n-label
    label="Connect Rentals"
    [optional]="true"
    [state]="stepper.selectedIndex > 3 ? 'done' : 'number'"
  >
    <app-connect-bdc-wizard-step4
      (prev)="stepper.previous()"
      (next)="stepper.next()"
      [channel]="channel"
      [propertyId]="propertyId"
      #step4
    ></app-connect-bdc-wizard-step4>
  </mat-step>
  <mat-step i18n-label label="Complete" [state]="stepper.selectedIndex > 4 ? 'done' : 'number'">
    <app-connect-bdc-wizard-complete
      [propertyId]="propertyId"
      (reset)="stepper.reset(); step2.reset(); step3.reset(); step4?.reset()"
      (channel)="onChannel()"
      (prev)="stepper.previous()"
      (done)="onDone()"
    ></app-connect-bdc-wizard-complete>
  </mat-step>
  <ng-template matStepperIcon="done">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
  <ng-template matStepperIcon="edit">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
</mat-stepper>
